// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__32Vo5","paramInput":"JobSimulator_paramInput__2WFoQ","input":"JobSimulator_input__2Lpz9"};